module.exports = __webpack_public_path__ + "media/unauthenticated/signin-manager-be233d63.png";